export default __webpack_public_path__ + "static/media/b5_question_dark.2228d348.webp";